import { useEffect } from 'preact/hooks';
import { teadsApi } from '../../teads-api';

export function useHideCredits() {
  useEffect(() => {
    teadsApi.hideCredits();
  }, []);
}
